import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTheme } from "@/components/ThemeProvider";

import "./content-with-sidebar.less";

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const defaultProps = {
  className: null,
  children: null,
};

// Sidebar

function Sidebar({ className, children, ...props }) {
  const { isDarkMode } = useTheme();
  return (
    <div className={classNames("layout-sidebar", className, { "dark-mode": isDarkMode })} {...props}>
      <div>{children}</div>
    </div>
  );
}

Sidebar.propTypes = propTypes;
Sidebar.defaultProps = defaultProps;

// Content

function Content({ className, children, ...props }) {
  const { isDarkMode } = useTheme();
  return (
    <div className={classNames("layout-content", className, { "dark-mode": isDarkMode })} {...props}>
      <div className={classNames({ "dark-mode": isDarkMode })}>{children}</div>
    </div>
  );
}

Content.propTypes = propTypes;
Content.defaultProps = defaultProps;

// Layout

export default function Layout({ children, className = undefined, ...props }) {
  const { isDarkMode } = useTheme();
  return (
    <div className={classNames("layout-with-sidebar", className, { "dark-mode": isDarkMode })} {...props}>
      {children}
    </div>
  );
}

Layout.propTypes = propTypes;
Layout.defaultProps = defaultProps;

Layout.Sidebar = Sidebar;
Layout.Content = Content;
